// 用户长时间未操作 退出登录
import router from "./router/index.js";
import { delCookie } from "./utils/utils.js";

var timer = null;

clearInterval(timer);

export function isOperateFun() {
  var lastTime = new Date().getTime(); // 最后一次点击时间
  var currentTime = new Date().getTime(); // 当前时间
  var timeOut = 240 * 60 * 1000; // 允许最长未操作时间
  var i = 1; // 辅助作用
  function handleReset() {
    i = 1;
    lastTime = new Date().getTime();
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (!timer) {
      handleInterval();
    }
  }

  document.onclick = () => {
    // 单击事件
    handleReset();
  };

  document.ondblclick = () => {
    // 双击事件
    handleReset();
  };

  document.onmousedown = () => {
    // 按下鼠标键时触发
    handleReset();
  };

  document.onmouseup = () => {
    // 释放按下的鼠标键时触发
    handleReset();
  };

  document.onmousemove = () => {
    // 鼠标移动事件
    handleReset();
  };

  document.onmouseover = () => {
    // 移入事件
    handleReset();
  };

  document.onmouseout = () => {
    // 移出事件
    handleReset();
  };

  document.onmouseenter = () => {
    // 移入事件
    handleReset();
  };

  document.onmouseleave = () => {
    // 移出事件
    handleReset();
  };
  function handleInterval() {
    // 定时器
    timer = setInterval(() => {
      currentTime = new Date().getTime(); // 当前时间
      // if (currentTime - lastTime > timeOut) {
      //   //console.log('长时间未操作')
      //   alert("长时间未操作!退出登录!");
      //   clearInterval(timer); // 清除定时器
      //   const path = window.location.href.split("#")[1];
      //   if (path !== "/login") {
      //     // 判断当前路由不是首页 则跳转至首页
      //     router.push("/login");
      //     delCookie("token");
      //   }
      //   window.AndroidWebView.loginOut(); // 执行安卓退出方法
      // }
    }, 1000);
  }

  handleInterval(); // 一开始程序 默认执行定制器
}



// WEBPACK FOOTER //
// ./src/app.js